import { StatusAnnouncer } from "../../../../shared/components/feedback/status-announcer.js";
import { PlaybackStatusIndicator, StatusIndicator } from "../../../components/feedback/status-indicator.js";
import { VolumeIndicator } from "../../../components/feedback/volume-indicator.js";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { cn } from "@videojs/utils/style";
//#region src/internal/skins/default-live-video/skins/shared/live-video/status-indicators.tsx
/** @jsxImportSource react */
function LiveVideoStatusIndicators({ className, ...props } = {}) {
	return /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(StatusAnnouncer, {}), /* @__PURE__ */ jsxs("div", {
		className: cn("video-status-indicators", className),
		...props,
		children: [
			/* @__PURE__ */ jsx(VolumeIndicator, {}),
			/* @__PURE__ */ jsx(StatusIndicator, {}),
			/* @__PURE__ */ jsx(PlaybackStatusIndicator, {})
		]
	})] });
}
//#endregion
export { LiveVideoStatusIndicators };

//# sourceMappingURL=status-indicators.js.map